const { assemblePdf } = require('../pdf/assemble.js');

angular.module('pdf').factory('PDF', [
  '$q', 'Spinner', 'Notification', 'jsPDF', 'dataPrep', 'imageHandler', 'components', 'Auth',
  function ($q, Spinner, Notification, jsPDF, dataPrep, imageHandler, components, Auth) {

    // DCL-558: the destination's website QR code is a Premium feature of the
    // practice generating the PDF. Basic users get the same PDF without it —
    // the image is simply never loaded, so appendQRCode draws nothing.
    const qrCodeAllowed = () => {
      const user = Auth.current_user;
      return !!(user && user.practice && user.practice.premium_access);
    };

    const createAndSave = (referral, filename, forPatient) => {
      const data = dataPrep.prepareData(referral);
      let jsPDFConstructor;

      Spinner.show();
      return $q.all([
        jsPDF.load(),
        dataPrep.loadCoBranding(data.originalPracticeData),
        dataPrep.loadCoBranding(data.destinationPracticeData),
      ])
        .then((results) => {
          jsPDFConstructor = results[0];
          return $q.all([
            imageHandler.loadCoBrandingImages(data.originalPracticeData),
            imageHandler.loadCoBrandingImages(data.destinationPracticeData),
            qrCodeAllowed() ? imageHandler.loadQrCode(data.destinationPracticeData) : $q.resolve(),
            imageHandler.prepareImages(data.attachments)
          ]);
        })
        .then(() => assemblePdf({
          jsPDF: jsPDFConstructor,
          components,
          data,
          forPatient
        }).save(filename))
        .catch((error) => {
          console.error('Error during PDF generation', error);
          Notification.error('Unable to generate the PDF. Please try again.');
        })
        .finally(() => Spinner.hide());
    };

    return { createAndSave };
  }
]);
